/*
 * @Author: your name
 * @Date: 2021-11-12 17:02:31
 * @LastEditTime: 2021-11-18 13:41:08
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\system\dict\dict.service.ts
 */
import { HttpService } from "@/core";
import {
  DictReq,
  DictPageReq,
  DictPageResp,
  DictDetailResp,
  DictGroupListResp,
  DictValRecord,
} from "./dict.interface";
import { message } from "ant-design-vue";
import { AxiosResponse } from "axios";
import { ResponseResp } from "@/core/interface";

const dictCacheMap = new Map();

export class DictService {
  static usePageApi() {
    const api = (params: DictPageReq) =>
      HttpService.backstageAxios({
        method: "GET",
        url: "/dict/page",
        params,
      });
    return HttpService.usePagination<DictPageResp>(api);
  }

  static async fetchOptionsByDictCode(dictCode: string): Promise<DictValRecord[]> {
    const cached = dictCacheMap.get(dictCode);
    if (dictCacheMap.get(dictCode)) {
      return cached;
    }
    let options: DictValRecord[] = [];
    try {
      const r: AxiosResponse<ResponseResp<DictGroupListResp>> = await HttpService.backstageAxios({
        method: "GET",
        url: "/dict/groupList",
        params: {
          dictCodes: dictCode,
        },
      });
      const res = r.data;
      if (res.respCode !== "0000") {
        message.error(res.respDesc);
        return options;
      }
      if (res.data.records.length === 1) {
        options = res.data.records[0].list;
        dictCacheMap.set(dictCode, options);
      }
    } catch (e: any) {
      message.error(e.message);
    }
    return options;
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.backstageAxios({
        method: "GET",
        url: `/dict/${id}`,
      });
    return HttpService.useRequest<DictDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: DictReq) =>
      HttpService.backstageAxios({
        method: "POST",
        url: "/dict",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: DictReq) =>
      HttpService.backstageAxios({
        method: "PUT",
        url: `/dict/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.backstageAxios({
        method: "DELETE",
        url: `/dict/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
